/** Features whose availability is decided by the backend for the current project. */
export enum AppFeature {
  SignedPunches = 'signedPunches',
  MyPunches = 'myPunches',
}
